import {
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
  MenuItem,
} from "@mui/material";
import { useConfig } from "../containers/ConfigContext";
import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { SurveyComplains } from "../containers/SurveyComplains";

export default function ComplainsPage() {
  const { loggedUser, localized } = useConfig();
  const { surveyEvents } = loggedUser || {};
  const [selectedEvent, setSelectedEvent] = useState<string>();
  const hideComplainsPage = loggedUser?.company?.showComplainsPage === false;

  useEffect(() => {
    if (surveyEvents?.length && !selectedEvent) {
      setSelectedEvent(surveyEvents[0].id);
    }
  }, [surveyEvents, selectedEvent]);

  if (hideComplainsPage) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "30rem",
        }}
      >
        <Typography variant="h6">
          You are not allowed to access this page
        </Typography>
      </div>
    );
  }

  return (
    <Stack spacing={3}>
      <Stack
        direction="row"
        width="100%"
        justifyContent={"flex-end"}
        sx={{ pr: 4 }}
      >
        <FormControl sx={{ width: 250 }}>
          <InputLabel id="event-select-label">{localized("Survey")}</InputLabel>
          <Select
            labelId="event-select-label"
            value={selectedEvent ?? ""}
            label="Survey"
            onChange={(e: SelectChangeEvent<string>) => {
              const newSelected = e.target.value;
              setSelectedEvent(newSelected);
            }}
            renderValue={(value) => {
              const event = surveyEvents?.find((e) => e.id === value);
              return event?.survey?.name ?? "";
            }}
          >
            {surveyEvents?.map((event) => (
              <MenuItem key={event.id} value={event.id}>
                <Stack gap={0.5}>
                  <Typography
                    variant="body1"
                    sx={{ whiteSpace: "normal", wordBreak: "break-word" }}
                  >
                    {event.survey?.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {localized("id")}: {event.id}
                  </Typography>
                </Stack>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      {selectedEvent && <SurveyComplains eventId={selectedEvent} />}
    </Stack>
  );
}
